import React, { Component } from "react";
import ReactTableComponent from "../tables/ReactTable";
//import { DotLoader } from "react-spinners";
import {
  addCustomerForm,
  getData,
  getLinkedinData,
  editCustomersValidation,
  customersValidation
} from "./CustomerConfig";
import Active from "../assets/Active.png";
import Inactive from "../assets/Inactive.png";
import AddCustomer from "../Form/AddNewForm";
// import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";

import EditCustomer from "../Form/EditForm";
import {
  TextField,
  //InputAdornment,
  MenuItem,
  Button,
  //Link,
  Drawer,
  Checkbox,
  FormControlLabel,
  //IconButton,
  Menu
} from "@material-ui/core";
//import MoreVertIcon from "@material-ui/icons/MoreVert";
import SearchIcon from "../assets/search.png";
import "./customer.css";
import { customersInfo } from "../../Queries";
import Edit from "../assets/edit.png";
import {
  addorEditCustomer,
  addorEditLinkedinProfile,
  updateCustomer,
 // updateCustomerLinkedinCreate
} from "./Customerquery";
import { connect } from "react-redux";
import Delete from "../assets/delete.png";
import NextArrow from "../assets/next-arrow.png";
import swal from "sweetalert";
import { fetchMethod } from "../../FetchMethod";
// import CheckIcon from "@material-ui/icons/Check";
// import ClearIcon from "@material-ui/icons/Clear";
import queryString from "querystring";
import { withRouter } from "react-router-dom";
class Customers extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      status2: null,
      status3: null,
      search: "",
      loading: false,
      customers: [],
      data: [],
      totalCount: 0,
      Row: [],
      header: "Customer Management",
      clear: [],
      editData: [],
      editLinkedinData: [],
      right: false,
      right1: false,
      limit: 50,
      offset: 50,
      searchFlag: false,
      clickToSearch: false,
      isEditMode: false,
      filterColumn: "",
      shortfilter: false,
      anchorEl: null,
      selectedCustomerRow: null
    };
  }
  componentDidMount() {
    localStorage.setItem("path", "/Customers");
    const hubSpotCode = queryString.parse(this.props.location.search);

    this.setState({
      right: !!hubSpotCode["?code"]
    });
    this.props.onHandleCampaign();
    this.props.onHandleSidebarText("/Customers");
  }
  toggleDrawer = (side, open, customer) => async event => {
    this.handleMenuClose();
    if (customer !== undefined) {
      this.setState({ Row: customer });
      let data = await getData(customer.id);
      this.setState({ editData: data.data.allCustomers.Customers[0] });
      let LinkedinData = await getLinkedinData(customer.id);

      this.setState(
        {
          editLinkedinData:
            LinkedinData.data.allCustomerlinkedinprofiles
              .Customerlinkedinprofiles
        },
        () => {
          this.props.onEditMode(open);
          this.props.getId(customer.id);
          return this.props.OnEdit(this.state.editLinkedinData);
        }
      );

      if (
        event &&
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }

      this.setState({ ...this.state, [side]: open });
    } else {
      if (
        event &&
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }
      this.props.OnClear(this.state.clear);
      this.setState({ ...this.state, [side]: open });
    }
  };

  setListData = response => {
    this.setState({
      customers: response.data.allCustomers.Customers,
      totalCount: response.data.allCustomers.totalCount
    });
  };

  onStatusChange = event => {
    var checkvalue = 1;
    var checkStatus = null;
    if (event.target.checked === false) {
      checkStatus = 0;
    } else {
      checkStatus = 1;
    }
    if (
      event.target.checked === false &&
      (this.state.status2 === 1 || this.state.status2 == null)
    ) {
      checkvalue = "All";
    }

    if (event.target.checked === true && this.state.status2 === 0) {
      checkvalue = "All";
    }
    if (event.target.checked === false && this.state.status2 == 0) {
      checkvalue = 0;
    }

    this.setState(
      {
        status3: checkStatus,
        status: checkvalue,
        clickToSearch: false
      },
      () => {
        this.onSearchClick();
      }
    );
  };
  onStatusChange2 = event => {
    var checkvalue = 0;
    var checkStatus = null;
    if (event.target.checked === false) {
      checkStatus = 1;
    } else {
      checkStatus = 0;
    }

    if (
      event.target.checked === false &&
      (this.state.status3 === 0 || this.state.status3 == null)
    ) {
      checkvalue = "All";
    }

    if (event.target.checked === true && this.state.status3 === 1) {
      checkvalue = "All";
    }
    if (event.target.checked === false && this.state.status3 === 1) {
      checkvalue = 1;
    }
    this.setState(
      {
        status2: checkStatus,
        status: checkvalue,
        clickToSearch: false
      },
      () => {
        this.onSearchClick();
      }
    );
  };
  handleMenuOpen = event => {
    this.setState({ anchorEl2: true, userData: event });
  };
  handleMenuClose = () => {
    this.setState({
      anchorEl: null
    });
  };

  showCustomerToPopup = (e, row) => {
    this.setState({
      selectedCustomerRow: {
        ...row.original
      },
      anchorEl: e.currentTarget,
      clientY: e.clientY,
      clientX: e.clientX
    });
  };
  ActionMenu = () => {
    return (
      <div>
        <Menu
          id="statusMenu"
          anchorEl={this.state.anchorEl}
          open={Boolean(this.state.anchorEl)}
          keepMounted
          style={{
            top:
              this.state.clientY < 80
                ? `${this.state.clientY}px`
                : `${this.state.clientY - 30}px`,

                left: this.state.clientX
          }}
          onClose={this.handleMenuClose}
        >
          <MenuItem
            onClick={this.toggleDrawer(
              "right1",
              true,
              this.state.selectedCustomerRow
            )}
          >
            <img src={Edit} alt="Delete" className="deleteButton" />
            Edit
          </MenuItem>
          <MenuItem
            onClick={() => this.onDelete(this.state.selectedCustomerRow)}
          >
            <img src={Delete} alt="Delete" className="deleteButton" />
            Inactive
          </MenuItem>
        </Menu>
      </div>
    );
  };
  // onDelete = user => {
  onDelete = user => {
    this.handleMenuClose();
    if (user.active === 1 || user.active === "1") {
      swal({
        title: "Are you sure you want to make this customer inactive?",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          const test = {
            id: { id: user.id },
            data: { active: 0 }
          };
          fetchMethod(updateCustomer, test)
            .then(response => {
              return response.json();
            })
            .then(res => {
              this.setState(
                {
                  loading: false
                },
                () => {
                  this.child.current.searchFetch(
                    this.state.limit,
                    this.state.offset
                  );
                }
              );
            })
            .catch(e => console.log(e));
        }
      });
    }
  };

  onSearchClick = () => {
    if (this.state.searchFlag === true) {
      this.setState({ clickToSearch: true }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
      });
    } else {
      this.setState({ clickToSearch: false }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
      });
    }
  };

  debounce = (debounceTimer, func, delay) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(func, delay);
    return debounceTimer;
  };
  debounceTimer = null;
  handleChange = event => {
    this.setState({
      search: event.target.value,
      searchFlag: true,
      isSearching: true
    });
    this.debounceTimer = this.debounce(
      this.debounceTimer,
      () => {
        this.onSearchClick();
        this.setState({ isSearching: false });
      },
      200
    );
  };

  debounce = (debounceTimer, func, delay) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(func, delay);
    return debounceTimer;
  };

  SetLimit = limit => {
    this.setState({
      limit
    });
  };

  SetOffset = offset => {
    this.setState({ offset });
  };
  setCustomerRowClick = rowInfo => {};
  onSearchKeyDown = event => {
    return event.key === "Enter" ? this.onSearchClick() : "";
  };

  NameFilter = () => {
    this.setState({ filterColumn: "company asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  NameFilter1 = () => {
    this.setState({ filterColumn: "company desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  render() {
    let { status, totalCount, clickToSearch, search } = this.state;
    let Search = clickToSearch ? search.trim().replace(/\s\s+/g, "") : "";
    Search = Search.split(" ");
    const like1 = `%${Search[0]}%`;
    // const like1 = "%" + `${Search[0]}` + "%";

    const filt = {
      or: [{ company: { like: like1, options: "i" } }]
    };
    const filter =
      localStorage.getItem("role") === "ADMIN"
        ? status === "All"
          ? {
              where: {
                createdby: localStorage.getItem("id"),
                filt,
                order: this.state.filterColumn
              }
            }
          : {
              where: {
                createdby: localStorage.getItem("id"),
                active: status,
                order: this.state.filterColumn,
                and: [filt]
              }
            }
        : status === "All"
        ? { where: { filt, order: this.state.filterColumn, and: [filt] } }
        : {
            where: {
              active: status,
              order: this.state.filterColumn,
              and: [filt]
            }
          };

    const thCustomersArray = [
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{ cursor: "pointer" }}
              onClick={
                this.state.shortfilter !== true
                  ? this.NameFilter
                  : this.NameFilter1
              }
            >
              Company Name
            </div>
          );
        },
        accessor: "Company_Name"
      },
      {
        Header: "Primary Contact",
        accessor: "Name"
      },
      {
        Header: "Phone Number",
        accessor: "contactno"
      },
      {
        Header: "Email Address",
        accessor: "email"
      },

      {
        Header: "Not Started",
        accessor: "Notstarted"
      },
      {
        Header: "Live ",
        accessor: "Live"
      },
      {
        Header: "Paused",
        accessor: "Paused"
      },
      {
        Header: "Completed",
        accessor: "Completed"
      },
        {
        Header: "Active",
        accessor: "Active",
      },
   
    ];

    const customerActions = [
      {
        Header: "Action",
        Cell: (row) => (
          <div className="iconButton ">
            <a onClick={this.toggleDrawer("right1", true, row.original)}>
              <img
                src={Edit}
                alt="Edit"
                className="editButton"
                width="20px"
                title="Edit"
              />
            </a>
            <a
              title="Deactivate"
              className="iconDelete"
              onClick={() => this.onDelete(row.original)}
            >
              <img src={Delete} alt="Delete" className="deleteButton" />
            </a>
          </div>
        ),
      },
    ];
    let customer = [...this.state.customers];

    customer.map(customer => {
      let fname =
        customer.firstName !== undefined && customer.firstName !== null
          ? customer.firstName
          : "";
      let lname =
        customer.lastName !== undefined && customer.lastName !== null
          ? customer.lastName
          : "";
      customer.Name = fname + " " + lname;

      customer.Notstarted = customer.NotStarted.totalCount;
      customer.Live = customer.LIVE.totalCount;
      customer.Paused = customer.PAUSED.totalCount;
      customer.Completed = customer.COMPLETED.totalCount;
      customer.Company_Name = (
        <div
          onClick={this.toggleDrawer("right1", true, customer)}
          style={{ cursor: "pointer" }}
        >
          {customer.company}
        </div>
      );
            customer.active === 1
        ? (customer.Active = (
            <img
              src={Active}
              alt="Active"
              title="Active"
              style={{ width: "20px" }}
            />
          ))
        : customer.active === 0
        ? (customer.Active = (
            <img
              src={Inactive}
              alt="Inactive"
              title="Inactive"
              style={{ width: "20px" }}
            />
          ))
        : (customer.Active = customer.Active);
    });

    return (
      <div className="Customer">
        <div className="top-flexbox">
          <div className="title-block">
            <h1>Customers</h1>
            <p>
              Total <span>{this.state.totalCount} Records</span>
            </p>
          </div>
          <div className="button-block">
            <Button
              variant="outlined"
              color="primary"
              onClick={this.toggleDrawer("right", true)}
            >
              A<span style={{ textTransform: "lowercase" }}>dd</span> &nbsp;N
              <span style={{ textTransform: "lowercase" }}>ew</span>
            </Button>
          </div>
        </div>
        <div className="modalButton-flex">
          <div className="statusSearchDiv">
            <div className="statusDiv">
              <TextField
                id="outlined-search"
                label="Search"
                type="text"
                margin="normal"
                variant="outlined"
                placeholder="Search Company name here..."
                onKeyDown={this.onSearchKeyDown}
                value={this.state.search}
                onChange={this.handleChange}
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  endAdornment: (
                    <img
                      src={SearchIcon}
                      style={{ width: "15px", cursor: "pointer" }}
                      onClick={() => this.onSearchClick()}
                    />
                  )
                }}
              />
            </div>

            <div className="searchCustomer">
              <FormControlLabel
                control={<Checkbox />}
                label="Active"
                onChange={this.onStatusChange}
                InputProps={{
                  endAdornment: (
                    <img src={NextArrow} alt="" style={{ width: "7px" }} />
                  )
                }}
              />
              <FormControlLabel
                control={<Checkbox />}
                label="Inactive"
                onChange={this.onStatusChange2}
                InputProps={{
                  endAdornment: (
                    <img src={NextArrow} alt="" style={{ width: "7px" }} />
                  )
                }}
              />
            </div>
          </div>
          <Drawer anchor="right" open={this.state.right}>
            <AddCustomer
              title="Add Customer"
              formConfig={addCustomerForm}
              modalClose={this.toggleDrawer("right", false)}
              className={"customerForm"}
              formValidation={customersValidation}
              query={addorEditCustomer}
              query1={addorEditLinkedinProfile}
              message="New customer added successfully"
              buttonName={"Save"}
              updateData={() =>
                this.child.current.searchFetch(
                  this.state.limit,
                  this.state.offset
                )
              }
            />
          </Drawer>
        </div>
        <Drawer anchor="right" open={this.state.right1}>
          <EditCustomer
            title="Edit Customer"
            formConfig={addCustomerForm}
            formValidation={editCustomersValidation}
            editableData={this.state.editData}
            editLinkedinData={this.state.editLinkedinData}
            modalClose={this.toggleDrawer("right1", false, this.state.Row)}
            className="customerForm"
            query={updateCustomer}
            buttonName={"Update"}
            message="Customer updated successfully"
            updateData={() =>
              this.child.current.searchFetch(
                this.state.limit,
                this.state.offset
              )
            }
          />
        </Drawer>
        {this.ActionMenu()}
        <ReactTableComponent
          ref={this.child}
          listData={customer}
          listConfig={thCustomersArray.concat(customerActions)}
          query={customersInfo}
          setData={this.setListData}
          totalCount={totalCount}
          setLimit={this.SetLimit}
          setOffset={this.SetOffset}
          filter={filter}
          clickToSearch={this.state.clickToSearch}
          onRowClick={this.setCustomerRowClick}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    OnEdit: editLinkedinData =>
      dispatch({ type: "Edit_Linkedin_Data", LinkedinId: editLinkedinData }),
    OnClear: clear =>
      dispatch({ type: "Clear_Linkedin_Data", Linkedindata: clear }),
    onEditMode: editMode =>
      dispatch({ type: "IsEditModeable", editMode: editMode }),
    getId: id => dispatch({ type: "GetId", id: id }),
    onHandleSidebarText: data =>
      dispatch({
        type: "HANDLE_SIDEBAR_TEXT",
        payload: data
      }),

    onHandleCampaign: data =>
      dispatch({ type: "Campaign_Detail", payload: null })
  };
};

export default connect(null, mapDispatchToProps)(withRouter(Customers));
